import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './animate.css';
import AppContainer from "./containers/app-container";
import {BrowserRouter} from "react-router-dom";
import Provider from "react-redux/es/components/Provider";
import store from './redux/redux-store'
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<BrowserRouter><Provider store={store}><AppContainer /></Provider></BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
